import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ActiveAntsPurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, ActiveAntsPurchaseOrderPaginationOptions, ActiveAntsPurchaseOrdersFilters } from "src/types";

const useActiveAntsPurchaseOrders = (
  activeAntsPurchaseOrderService: ActiveAntsPurchaseOrderService,
  dateTimeRange?: DateTimeRange,
  filter?: ActiveAntsPurchaseOrdersFilters,
  paginationOptions?: ActiveAntsPurchaseOrderPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getActiveAntsPurchaseOrdersQueryParams(
    dateTimeRange,
    filter,
    paginationOptions
  );

  const {
    data: paginatedActiveAntsPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedActiveAntsPurchaseOrders(queryParams),
    queryFn: () => activeAntsPurchaseOrderService.getActiveAntsPurchaseOrders(queryParams)
  });

  const refreshActiveAntsPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedActiveAntsPurchaseOrders(),
      exact: false
    });
  };

  return { paginatedActiveAntsPurchaseOrders, fetchError, isLoading, refreshActiveAntsPurchaseOrders };
};

export { useActiveAntsPurchaseOrders };
